import { takeLatest, all, put, fork, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import * as actions from '../actions/actions'

import { change, recover } from '../../api/passwordApi'
import {updatePassword} from "../../api/userApi";

export default function* passwordSaga() {
  yield all([
    fork(watchRecoverPasswordRequest),
    fork(watchChangePasswordRequest),
    fork(watchChangeResetPasswordRequest),
    fork(watchRecoverPasswordPageRequest)
  ]);
}

function* watchRecoverPasswordRequest() {
  yield takeLatest(
    actions.RECOVER_PASSWORD_REQUEST,
    recoverPasswordRequest
  )
}

function* recoverPasswordRequest(recoverData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(recover, recoverData.value)
    yield put({ type: actions.RECOVER_PASSWORD_SUCCESS, value: data })
    yield put(push(`/${localStorage.getItem('bank')}`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    yield put({ type: actions.RECOVER_PASSWORD_FAILURE, error: error.response })
  }
}

function* watchRecoverPasswordPageRequest() {
  yield takeLatest(
      actions.AUTHENTICATION_RECOVERY_REQUEST,
      recoverPasswordPageRequest
  )
}

function* recoverPasswordPageRequest() {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    yield put(push(`/${localStorage.getItem('bank')}/recover`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    yield put({ type: actions.RECOVER_PASSWORD_FAILURE, error: error.response })
  }
}

function* watchChangePasswordRequest() {
  yield takeLatest(
    actions.CHANGE_PASSWORD_REQUEST,
    changePasswordRequest
  )
}

function* changePasswordRequest(passwordData) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(change, passwordData.value)
    yield put({ type: actions.CHANGE_PASSWORD_SUCCESS, value: data })
    yield put(push(`/${localStorage.getItem('bank')}`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.CHANGE_PASSWORD_FAILURE, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }
  }
}


function* watchChangeResetPasswordRequest() {
  yield takeLatest(
      actions.CHANGE_RESET_PASSWORD_REQUEST,
      changeResetPasswordRequest
  )
}

function* changeResetPasswordRequest(passwordData) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(updatePassword, passwordData.value)
    yield put({ type: actions.CHANGE_PASSWORD_SUCCESS, value: data })
    yield put({ type: actions.AUTHENTICATION_CLEAR_RESET_PASSWORD, value: data })
    yield put(push(`/index`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.CHANGE_PASSWORD_FAILURE, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }
  }
}